// Orders utilities
const ORDERS_FILE_KEY = 'autochef_orders';

export const saveOrder = (order) => {
  try {
    const orders = getOrders();
    const newOrder = {
      ...order,
      id: Date.now(),
      timestamp: new Date().toISOString()
    };
    orders.push(newOrder);
    localStorage.setItem(ORDERS_FILE_KEY, JSON.stringify(orders, null, 2));
    
    // Also trigger download of JSON file for backup
    downloadOrdersJSON(orders);
    
    return newOrder;
  } catch (error) {
    console.error('Error saving order:', error);
    return null;
  }
};

export const getOrders = () => {
  try {
    const orders = localStorage.getItem(ORDERS_FILE_KEY);
    return orders ? JSON.parse(orders) : [];
  } catch (error) {
    console.error('Error getting orders:', error);
    return [];
  }
};

export const downloadOrdersJSON = (orders) => {
  try {
    const dataStr = JSON.stringify(orders, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `orders_${new Date().toISOString().split('T')[0]}.json`;
    // Don't auto-download, just keep in localStorage
    // link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading orders:', error);
  }
};

export const clearOrders = () => {
  localStorage.removeItem(ORDERS_FILE_KEY);
};
